import { Component, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { Observable } from "rxjs";
import { UpdateFormFieldType } from "projects/backoffice/src/app/shared/const/enums/update-form-field-type.enum";
import { UpdateFormFieldData } from "../const/models/update-form-field-data.model";
import { BaseDialogActionData, ButtonColor, CommonActionKey } from "common";

@Component({
    selector: "ifb-update-dialog",
    templateUrl: "./update-dialog.component.html",
    styleUrls: ["./update-dialog.component.scss"],
    standalone: false
})
export class UpdateDialogComponent {
  actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.Cancel, label: 'Cancel', buttonColor: ButtonColor.Default },
    { actionKey: CommonActionKey.Ok, label: 'Ok', buttonColor: ButtonColor.Primary },
  ];

  actionGerund: string;
  objectName: string;
  title: string;

  get FieldType() {
    return UpdateFormFieldType;
  }

  constructor(
    public dialogRef: MatDialogRef<UpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.actionGerund = this.data.action.substring(0, this.data.action.length - 1) + "ing";
    this.objectName = this.data.objectName;
    this.title = `${this.data.action} ${this.objectName}?`
  }

  static show(
    dialog: MatDialog,
    updatedFieldsData: UpdateFormFieldData[],
    action: string,
    objectName: string
  ): Observable<any> {
    return dialog
      .open(UpdateDialogComponent, {
        width: "510px",
        data: {
          updatedFieldsData: updatedFieldsData,
          action,
          objectName: objectName
        },
        closeOnNavigation: true,
      })
      .afterClosed();
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    if (actionData.actionKey === CommonActionKey.Ok) {
      this.dialogRef.close(true);
      return;
    }

    this.dialogRef.close(false);
  }
}

